import { ApiResponseContent } from '../models/custom-models';
import { CreateDevelopmentItem } from './DevelopmentClient';
import ApiBase from './base/ApiBase'

class AssessmentClient extends ApiBase {
    private controllerName: string = 'Assessment';

    // async Delete(id: string, signal?: AbortSignal): Promise<void> {
    //     return this.DeleteAsync(`${this.controllerName}/${id}`, signal);
    // }

    async GetAll(signal?: AbortSignal): Promise<ApiResponseContent<AssessmentDisplay[]>> {
        return this.GetAsync(`${this.controllerName}`, signal);
    }

    async GetAllByTalent(talentId: string, signal?: AbortSignal): Promise<ApiResponseContent<AssessmentDisplay[]>> {
        return this.GetAsync(`${this.controllerName}/Talent/${talentId}`, signal);
    }

    async GetSingle(id: string, signal?: AbortSignal): Promise<ApiResponseContent<AssessmentGraph>> {
        return this.GetAsync(`${this.controllerName}/${id}`, signal);
    }

    async Publish(context: AssessmentPublishContext, signal?: AbortSignal): Promise<ApiResponseContent<string>>{
        return this.PostAsync(`${this.controllerName}/Talent/${context.TalentId}/Publish`, context, signal);
    }
    
    async Validate(talentId: string, signal?: AbortSignal): Promise<ApiResponseContent<ValidationResult<string>>> {
        return this.PostAsync(`${this.controllerName}/Talent/${talentId}/Validate`, signal);
    }

}


export class AssessmentPublishContext {
    TalentId: string;
    DevelopmentPlanItems: CreateDevelopmentItem[];
}

export class AssessmentDisplay{
    Id: string = "";
    AssessorName: string;
    LastName: string = "";
    FirstName: string = "";
    TemplateName: string;
    OverallRating: string;
    CreatedDate: string;
}

export class AssessmentProficiencyDisplay {
    GroupName: string;
    ProficiencyName: string;
    ProficiencyType: string;
    Selection: string;
}

export class AssessmentGroupScore {
    GroupName: string;
    Score: string;
    Proficiencies: AssessmentProficiencyDisplay[];
}

export class AssessmentGraph extends AssessmentDisplay {
    OverallScore: string = "";
    GroupScores: AssessmentGroupScore[];
}

export interface ValidationResult<T>{
    IsValid: boolean;
    IsNotValid: boolean;
    ValidationErrors: string[];
    Content: T;
}


export enum AssessmentErrors {
    // Delete = 'Error deleting Assessment',
    GetAll = 'Error loading Assessment',
    GetSingle = 'Error loading Assessment',
    Publish = 'Error publishing Assessment',
}

export default AssessmentClient;